<template>
  <div class="geography geography1">
    <div class="indicatorbanner">
      <div class="indicatorCon">
        <div class="conleft">
          <div class="leftTitle">{{ headerList.columnTitle }}</div>
          <div class="leftCon">
            <span>{{ headerList.columnDesc }}</span>
          </div>
        </div>
        <div class="conRight">
          <div
            class="conRight_img"
            v-for="(item, index) in headerList.proList"
            :key="index"
            @click="conRightimg(item.geoId, index)"
          >
            <div style="width: 120px; height: 120px">
              <img
                style="width: 100%; hieght: 100%; border-radius: 50%"
                :src="
                  item.url
                    ? commonUrl + item.url
                    : '../../../../static/images/pro_img.png'
                "
                alt=""
              />
            </div>
            <p>{{ item.geoProdName }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="header">{{ ShowOther.columnTitle }}</div>
    <div class="main">
      <div class="main_left">
        <div class="main_left_header">
          <div class="main_left_title">{{ ShowOther.subTitle }}</div>
          <div class="main_left_gis">
            <p>{{ ShowOther.columnDesc }}</p>
            <!-- <p>风味品质特征情况</p> -->
          </div>
          <div class="main_left_img">
            <img src="../../../../static/images/products.png" alt="" />
          </div>
        </div>
        <div class="main_left_footer">
          <!-- <div class="main_left_checkbox">
            <el-checkbox-group v-model="checkList">
              <el-checkbox
                style="display: block; padding-top: 10px"
                label="地标产品"
              ></el-checkbox>
              <el-checkbox
                style="display: block; padding-top: 10px"
                label="绿色产品"
              ></el-checkbox>
              <el-checkbox
                style="display: block; padding-top: 10px"
                label="特色农产品"
              ></el-checkbox>
            </el-checkbox-group>
          </div> -->
          <!-- <div class="line">
            <p></p>
          </div> -->
          <div class="ProducTtype">
            <p>
              {{ ShowOther.catgName }}
              <span class="ProducTtype_span" @click="genghuan"
                >更换产品类型</span
              >
            </p>
          </div>
          <div class="main_left_search">
            <el-input
              placeholder="请输入搜索"
              @input="searchinput"
              v-model="params.catgName"
            >
              <i
                @click.stop="addsearch"
                slot="suffix"
                style="cursor: pointer"
                class="el-input__icon el-icon-search"
              ></i>
            </el-input>
          </div>
          <div class="main_left_fruit1">
            <div
              class="main_left_subclass"
              :class="indexs == 0 ? 'main_left_switchIndex' : ''"
              @click="switchIndex(0, '', '')"
            >
              <div>全部</div>
            </div>
            <div
              class="main_left_subclass"
              :class="indexs == index + 1 ? 'main_left_switchIndex' : ''"
              v-for="(item, index) in resultList"
              :key="index"
              @click="switchIndex(index + 1, item.id, item.catgName)"
            >
              <div>{{ item.catgName }}</div>
            </div>
          </div>
          <div class="ProducTtypes">
            <p>区域查询</p>
          </div>
          <div class="main_left_search">
            <el-select
              v-model="provcode"
              @change="linkagetchange"
              clearable
              placeholder="请选择省份"
            >
              <el-option
                v-for="item in linkagetoptions"
                :key="item.code"
                :label="item.name"
                :value="item.code"
              >
              </el-option>
            </el-select>
            <!-- <el-input
              placeholder="请输入产品名称"
              suffix-icon="el-icon-search"
              v-model="input"
            >
            </el-input> -->
          </div>
        </div>
      </div>
      <div class="main_right">
        <div class="main_search">
          <div style="margin-right: 36px">
            <p class="main_search_p">风味品质特征指标 1</p>
            <div style="width: 142px" class="main_search_input">
              <el-select
                @clear="optionclear(params.pIndexPos[0].compoundId, 0)"
                @change="optionselect(params.pIndexPos[0].compoundId, 0)"
                v-model="params.pIndexPos[0].compoundId"
                clearable
                filterable
                placeholder=""
              >
                <el-option
                  style="width: 140px"
                  v-for="item in pIndexPos"
                  :key="item.id"
                  :title="item.commonNameCn"
                  :label="item.commonNameCn"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-right: 36px">
            <p class="main_search_p">指标数值范围</p>
            <div class="main_search_input">
              <span style="width: 60px; display: inline-block"
                ><el-input
                  autocomplete="off"
                  v-model="params.pIndexPos[0].startItemValue"
                  :disabled="params.pIndexPos[0].flag"
                  placeholder=""
                ></el-input
              ></span>
              <span>-</span>
              <span style="width: 60px; display: inline-block"
                ><el-input
                  autocomplete="off"
                  v-model="params.pIndexPos[0].endItemValue"
                  :disabled="params.pIndexPos[0].flag"
                  placeholder=""
                ></el-input
              ></span>
              <!-- <span>g</span> -->
            </div>
          </div>
          <div style="margin-right: 36px">
            <p class="main_search_p">风味品质特征指标 2</p>
            <div style="width: 142px" class="main_search_input">
              <el-select
                filterable
                @clear="optionclear(params.pIndexPos[1].compoundId, 1)"
                @change="optionselect(params.pIndexPos[1].compoundId, 1)"
                v-model="params.pIndexPos[1].compoundId"
                clearable
                placeholder=""
              >
                <el-option
                  style="width: 140px"
                  v-for="item in pIndexPos"
                  :key="item.id"
                  :title="item.commonName"
                  :label="item.commonNameCn"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div style="margin-right: 68px">
            <p class="main_search_p">指标数值范围</p>
            <div class="main_search_input">
              <span style="width: 60px; display: inline-block"
                ><el-input
                  autocomplete="off"
                  v-model="params.pIndexPos[1].startItemValue"
                  :disabled="params.pIndexPos[1].flag"
                  placeholder=""
                ></el-input
              ></span>
              <span>-</span>
              <span style="width: 60px; display: inline-block"
                ><el-input
                  autocomplete="off"
                  v-model="params.pIndexPos[1].endItemValue"
                  :disabled="params.pIndexPos[1].flag"
                  placeholder=""
                ></el-input
              ></span>
              <!-- <span>g</span> -->
            </div>
          </div>
          <div class="main_search_btn">
            <el-button type="warning" @click="findMapListForProArea"
              >查询</el-button
            >
          </div>
        </div>
        <div class="main_echarts">
          <div id="echarts" style="width: 100%; height: 100%"></div>
          <div class="Distribution_map">
            <p
              style="
                color: #222222;
                font-size: 18px;
                margin-bottom: 6px;
                font-weight: 900;
              "
            >
              {{ params.catgNames }}的全国分布图
            </p>
            <p style="color: #222222; font-size: 14px; margin-bottom: 10px">
              {{ params.catgNames }}的全国共有产品
              <span style="color: #f33e3e">{{ MapList.sumCount }}</span> 个，共
              <span style="color: #f33e3e">{{ MapList.varietyCount }}</span>
              个品种，分布在
              <span style="color: #f33e3e">{{ MapList.provCount }}</span> 个省
              <!-- <span style="color: #f33e3e">10</span> 个县域内 -->
            </p>
            <div class="main_search_btn">
              <el-button type="warning" @click="buttondis">查询更多</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="geography_el_dialog"
      title="产品类型"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <!-- <span>这是一段信息</span> -->
      <p style="margin-bottom: 10px">
        <el-input placeholder="请输入搜索" v-model="filterText"> </el-input>
      </p>
      <el-tree
        style="height: 400px; overflow: auto"
        :data="data"
        :check-on-click-node="false"
        class="geography_tree"
        @check="changetree"
        @check-change="handleNodeClick"
        :filter-node-method="filterNode"
        check-strictly
        ref="treeForm"
        show-checkbox
        :default-expanded-keys="expandedkeys"
        node-key="id"
        :props="defaultProps"
        empty-text="暂无数据"
      ></el-tree>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="treeVisible">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import "echarts/map/js/china.js";
// import  '../../../../node_modules/echarts/province/heilongjiang'

export default {
  // props:['pIndexPos'],
  watch: {
    filterText(val) {
      this.$refs.treeForm.filter(val);
    },
  },
  data() {
    return {
      defaultProps2: {
        children: "children",
        label: "label",
      },
      data2: [
        {
          id: 1,
          label: "一级 1",
          children: [
            {
              id: 4,
              label: "二级 1-1",
              children: [
                {
                  id: "9",
                  label: "三级 1-1-1",
                },
                {
                  id: 10,
                  label: "三级 1-1-2",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "一级 2",
          children: [
            {
              id: 5,
              label: "二级 2-1",
            },
            {
              id: 6,
              label: "二级 2-2",
            },
          ],
        },
        {
          id: 3,
          label: "一级 3",
          children: [
            {
              id: 7,
              label: "二级 3-1",
            },
            {
              id: 8,
              label: "二级 3-2",
            },
          ],
        },
      ],
      expandedkeys: [],
      input: "",
      indexs: 0,
      filterText: "",
      commonUrl: commonUrl,
      dialogVisible: false,
      value: "",
      checkList: [],
      headerList: {},
      ShowOther: {},
      MapList: {},
      resultList: [],
      selectName: "",
      linkagetoptions: [],
      provName: "",
      provcode: "",
      productClassId: "",
      params: {
        areaCity: "",
        areaCun: "",
        areaProv: "",
        pIndexPos: [
          {
            endItemValue: "",
            compoundId: "",
            startItemValue: "",
            flag: true,
          },
          {
            endItemValue: "",
            compoundId: "",
            startItemValue: "",
            flag: true,
          },
        ],
        productClassIds: "",
      },
      data: [],
      catgName: "",
      defaultProps: {
        children: "children",
        label: "catgName",
        id: "id",
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕",
        },
        {
          value: "选项2",
          label: "双皮奶",
        },
        {
          value: "选项3",
          label: "蚵仔煎",
        },
        {
          value: "选项4",
          label: "龙须面",
        },
        {
          value: "选项5",
          label: "北京烤鸭",
        },
      ],
      pIndexPos: [],
    };
  },

  created() {},
  mounted() {
    this.getFloorIndexShowOther();
    this.getFindexShowAreaMap();
    this.findClassMageTree();
    this.linkageList();
    this.allOneList();
  },
  methods: {
    searchinput() {
      this.debounce(this.getSearchSuggest, 500);
    },
    debounce(fn, delay) {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      this.timeout = setTimeout(() => {
        // this.getSearchSuggest()
        this.addsearch();
      }, delay);
    },
    conRightimg(id) {
      window.open("productSeachDetails?id=" + id, "_blank");
    },
    optionselect(item, index) {
      this.params.pIndexPos[index].flag = false;
    },
    optionclear(item, index) {
      this.params.pIndexPos[index].flag = true;
      this.params.pIndexPos[index].startItemValue = "";
      this.params.pIndexPos[index].endItemValue = "";
    },
    allOneList() {
      this.Axios({
        url: Action.N_ALLONELIST,
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.code == "000") {
          let arr = res.data.result.map((item, index) => {
            return item.id;
          });
          this.chemicalSearchNoPage(arr);
        }
      });
    },
    chemicalSearchNoPage(arr) {
      console.log(arr, "chemicalSearchNoPage");
      this.Axios({
        url: Action.REPLENISH_SELCHEMICALSEARCH,
        method: "post",
        data: {
          typeIds: arr,
        },
      }).then((res) => {
        if (res.data.code == "000") {
          this.pIndexPos = res.data.result;
        }
      });
    },
    linkagetchange() {
      let arr = this.linkagetoptions.filter((item, index) => {
        return item.code == this.provcode;
      });
      //  console.log(arr,'arr')
      this.provName = arr[0].name;
      this.drawChart();
    },
    // 首页-农产品地理查询-产品类型下所有的产品列表
    addsearch() {
      this.findProClassChildList(this.ShowOther.productClassId);
    },
    // AREA_LINKAGELIST
    linkageList() {
      this.Axios({
        url: Action.AREA_LINKAGELIST,
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.code == "000") {
          this.linkagetoptions = res.data.result;
          //  this.$refs.treeForm.setCheckedKeys([this.ShowOther.productClassId])

          // this.listD= res.data.result.splice(0, 5);
        }
        // console.log(res,'res')
      });
    },
    findProClassChildList(ids) {
      this.Axios({
        url: Action.FLOORINDEX_FINDPROCLASSCHILDLIST,
        method: "post",
        data: {
          ids: ids,
          catgName: this.params.catgName,
        },
      }).then((res) => {
        if (res.data.code == "000") {
          console;
          this.resultList = res.data.result;
          this.indexs = 0;
          // this.params.catgNames=this.params.catgName
          //  this.$refs.treeForm.setCheckedKeys([this.ShowOther.productClassId])

          // this.listD= res.data.result.splice(0, 5);
        }
        // console.log(res,'res')
      });
    },

    treeVisible() {
      console.log(this.selectName, "this.selectName");
      this.dialogVisible = false;
      if (this.ShowOther.productClassId != this.productClassId) {
        this.ShowOther.catgName = this.selectName;
        this.params.catgNames = this.selectName;
        this.ShowOther.productClassId = this.productClassId;
        this.findMapListForProArea();
        this.findProClassChildList(this.ShowOther.productClassId);
      }

      // console.log(this.productClassId, " this.ShowOther.catgName");
    },
    expandNode(node, nodeDataIds) {
      console.log(node.id, "node.data");
      let that = this; //当前结点需要展开未展开，则展开(根结点默认展开)
      if (node.level == 0 || nodeDataIds.indexOf(node.id) != -1) {
        //展开孩子结点
        let expandChildren = function () {
          console.log(node.childNodes, "node.childNodes");
          let childNodes = node.childNodes;
          for (let i = 0; i < childNodes.length; i++) {
            let childNode = childNodes[i]; //递归展开孩子结点
            that.expandNode(childNode, nodeDataIds);
          }
        };
        if (!node.expanded) {
          //当前结点未展开则先展开，展开后再展开孩子结点
          node.expand(function () {
            expandChildren();
          });
        } else {
          //当前结点已展开，直接展开孩子结点
          expandChildren();
        }
      }
    },
    genghuan() {
      this.dialogVisible = true;
      setTimeout(() => {
        let treeForm = this.$refs.treeForm;
        let rootNode = treeForm.root;
        //  rootNode.expanded=false
        treeForm.setCheckedKeys([this.ShowOther.productClassId]);
        this.expandedkeys = [this.ShowOther.productClassId];
        // this.expandNode(rootNode, this.ShowOther.productClassId);
      }, 200);
    },
    findClassMageTree() {
      this.Axios({
        url: Action.PRODUCTCLASSMAGE_FINDCLASSMAGETREEFORLEVEL,
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.code == "000") {
          // console.log(res.data.result, "findClassMageTree");
          this.data = res.data.result;
          //  this.$refs.treeForm.setCheckedKeys([this.ShowOther.productClassId])

          // this.listD= res.data.result.splice(0, 5);
        }
        // console.log(res,'res')
      });
    },
    findMapListForProArea() {
      // let arrflag=true
      this.params.pIndexPos.forEach((item) => {
        if (item.compoundId) {
          // console.log(!item.startItemValue, !item.endItemValue);
          if (item.startItemValue && item.endItemValue) {
            item.flag1 = true;
          } else {
            //  console.log('item.endItemValue)')
            item.flag1 = false;
          }
        } else {
          item.flag1 = true;
        }
      });
      let arrflag = this.params.pIndexPos.every((item, index) => {
        return item.flag1;
      });
      if (arrflag) {
        this.Axios({
          url: Action.FLOORINDEX_FINDMAPLISTFORPROAREA,
          method: "post",
          data: this.params,
        }).then((res) => {
          if (res.data.code == "000") {
            if (res.data.result) {
              this.MapList = res.data.result;
              this.drawChart();
            } else {
              this.MapList.list = [];
              this.MapList.provCount = 0;
              this.MapList.sumCount = 0;
              this.MapList.varietyCount = 0;
              this.drawChart();
            }

            // console.log(this.MapList, " this.MapList");
            // this.listD= res.data.result.splice(0, 5);
          }
          // console.log(res,'res')
        });
      } else {
        return this.$message({
          message: "请输入指标数值区间",
          type: "warning",
        });
      }
      // console.log(arrflag,'arrflag')
    },
    getFindexShowAreaMap() {
      //  PGEO_GET
      this.Axios({
        url: Action.FLOORINDEX_GETFINDEXSHOWAREAMAP,
        method: "post",
        data: {},
      }).then((res) => {
        if (res.data.code == "000") {
          this.headerList = res.data.result;
          // this.listD= res.data.result.splice(0, 5);
        }
        // console.log(res,'res')
      });
    },
    getFloorIndexShowOther() {
      //  PGEO_GET
      this.Axios({
        url: Action.GETFLOORINDEXSHOWOTHER,
        method: "post",
        data: {
          sort: "6",
        },
      }).then((res) => {
        console.log(res, "res111");
        if (res.data.code == "000") {
          this.ShowOther = res.data.result;
          this.productClassId = this.ShowOther.productClassId;
          this.params.productClassIds = this.ShowOther.productClassId;
          this.params.catgNames = this.ShowOther.catgName;
          // this.params.productClassIds=this.ShowOther.productClassIds
          // this.params.productClassIds = "";
          this.findMapListForProArea();
          this.findProClassChildList(this.ShowOther.productClassId);
          // this.$refs.treeForm.setCheckedKeys([this.ShowOther.productClassId]);
          // this.listD= res.data.result.splice(0, 5);
        }
        // console.log(res,'res')
      });
    },
    //
    filterNode(value, data) {
      if (!value) return true;
      return data.catgName.indexOf(value) !== -1;
    },
    handleNodeClick(data, checked, node) {
      // console.log("多选框设为单选框", checked, data);
      // console.log(this.$refs.treeForm);
      // console.log("data:  " + JSON.stringify(data));
      // console.log(this.$refs.treeFrom.current-node-key)
      if (checked) {
        this.$refs.treeForm.setCheckedKeys([data.id]);
      }
    },

    changetree(data, lst) {
      // console.log("lst:  " +this.$refs.treeForm, JSON.stringify(lst));
      // console.log(lst.checkedKeys.length);
      this.params.productClassIds = data.id;
      this.productClassId = data.id;
      // console.log(data.catgName,'data.catgName')
      this.selectName = data.catgName;
      if (lst.checkedKeys.length == 0) {
        //这里的treeForm是你el-tree命名的ref的值
        this.$refs.treeForm.setCheckedKeys([data.id]);
      }
      // this.getRightList()
    },

    handleClose(done) {
      done();
    },
    switchIndex(index, id, catgName) {
      this.indexs = index;
      if (id) {
        this.params.productClassIds = id;
        this.params.catgNames = catgName;
      } else {
        this.params.productClassIds = this.productClassId;
        this.params.catgNames = this.ShowOther.catgName;
      }

      this.findMapListForProArea();
      console.log(index);
    },
    // drawChart(){},
    drawChart() {
      let myChart = this.$echarts.init(document.getElementById("echarts"));
      var outdata = [];
      var max = 6000,
        min = 10;
      var maxSize4Pin = 100,
        minSize4Pin = 20;
      // console.log(this.MapList,'this.MapList.list')
      outdata = this.MapList.list.map((item, index) => {
        return {
          ...item,
          name: item.provShortName || "",
          value: item.count || "",
          itemStyle: {
            normal: { areaColor: "#CAD9F2" },
            emphasis: { areaColor: "#0050FF" },
          },
        };
      });
      outdata.forEach((item, index) => {  
        if (item.provName == this.provName) {
          item.itemStyle = {
            normal: { areaColor: "#0050FF" },
            emphasis: { areaColor: "#0050FF" },
          };
        }
      });
      console.log(myChart, "myChart");
      var geoCoordMap = {};
      /*获取地图数据*/
      var mapFeatures = this.$echarts.getMap("china").geoJson.features;
      //  var mapFeatures=myChart.registerMap('china',china)
       console.log(mapFeatures)
      mapFeatures.forEach(function (v) {
        // console.info(v);
        // 地区名称
        var name = v.properties.name;
        // 地区经纬度
        geoCoordMap[name] = v.properties.cp;
      });
      var convertData = function (outdata) {
        var res = [];
        for (var i = 0; i < outdata.length; i++) {
          var geoCoord = geoCoordMap[outdata[i].name];
          if (geoCoord) {
            res.push({
              name: outdata[i].name,
              value: geoCoord.concat(outdata[i].value),
              areaProv: outdata[i].areaProv,
              provShortName: outdata[i].provShortName,
              provName: outdata[i].provName,
            });
          }
        }
        return res;
      };

      let option = {
        backgroundColor: "#fff",

        tooltip: {
          show: true,
          formatter: function (params) {
            if (params.value.length > 1) {
              return `&nbsp;&nbsp;${params.name}&nbsp;&nbsp;&nbsp;${
                params.value[2] || 0
              }个产品&nbsp;&nbsp;`;
            } else {
              return `&nbsp;&nbsp;${params.name}&nbsp;&nbsp;&nbsp;${
                params.value || 0
              }个产品&nbsp;&nbsp;`;
            }
          },
        },

        geo: [
          {
            map: "china",
            show: false,
            roam: false,

            label: {
              emphasis: {
                show: false,
              },
            },
            layoutSize: "100%",
            itemStyle: {
              normal: {
                borderColor: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#CAD9F2",
                    },
                    {
                      offset: 1,
                      color: "#CAD9F2",
                    },
                  ],
                  false
                ),
                borderWidth: 3,
                shadowColor: "#fff",
                shadowOffsetY: 0,
                shadowBlur: 0,
              },
            },
          },
          {
            map: "china",
            show: true,
            top: "10.5%",
            roam: false,

            label: {
              emphasis: {
                show: false,
              },
            },

            layoutSize: "100%",
            itemStyle: {
              normal: {
                borderColor: new this.$echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "#CAD9F2",
                    },
                    {
                      offset: 1,
                      color: "#CAD9F2",
                    },
                  ],
                  false
                ),
                borderWidth: 3,
                shadowColor: "#fff",
                shadowOffsetY: 0,
                shadowBlur: 0,
              },
              emphasis: {
                show: false,
                // 鼠标经过时后的颜色
                areaColor: "#CAD9F2",
                // areaColor: 'black',
                borderWidth: 0,
              },
            },
            emphasis: {
              disabled: false,
            },
          },
        ],
        series: [
          {
            type: "map",
            map: "china",
            aspectScale: 0.75,
            //zoom:1.1,
            label: {
              normal: {
                show: false,
                formatter: "{b}",
                position: [-12, -1],
                color: "#ffffff",
              },
              emphasis: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                areaColor: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#CAD9F2", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#CAD9F2", // 100% 处的颜色
                    },
                  ],
                },
                borderColor: "#fff",
                borderWidth: 1,
              },
              emphasis: {
                areaColor: {
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "#0050FF", // 0% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "#0050FF", // 100% 处的颜色
                    },
                  ],
                },
              },
            },
            data: outdata,
          },
          {
  type: "effectScatter",
  coordinateSystem: "geo",
  rippleEffect: {
    brushType: "stroke",
  },
  showEffectOn: "render",
  itemStyle: {
    color: {
      type: "radial",
      x: 0.1,
      y: 0.1,
      r: 0.1,
      colorStops: [
        { offset: 0, color: "rgba(0,44,142,100)" },
        { offset: 1, color: "rgba(44,110,255,100)" },
      ],
      global: false, // 缺省为 false
    },
  },
  label: {
    show: true,
    color: "#fff",
    fontWeight: "bold",
    position: "inside",
    formatter: function (para) {
      return "{cnNum|" + para.data.value[2] + "}";
    },
    rich: {
      cnNum: {
        fontSize: 13,
        color: "#D4EEFF",
      },
    },
  },
  symbol: "circle",
  symbolSize: (function () {
    var a = (maxSize4Pin - minSize4Pin) / (max - min);
    var b = maxSize4Pin - a * max;
    return function (val) {
      return val[2] === 0 ? 0 : a * val[2] + b * 1;
    };
  })(),
  data: convertData(outdata), // 如果 convertData(outdata) 是静态的，可以提前计算并缓存
}
        ],
      };
      let _this = this;
      myChart.on("click", function (params) {
        console.log(params.data.name, "params");
        if(params.data.name=="黑龙江"){
          _this.$router.push({
          path: "hlj",
        });
        }else{
          _this.$router.push({
          path: "productSeach",
          query: {
            areaProv: params.data.areaProv,
            provName: params.data.provName,
            params: JSON.stringify(_this.params),
            productClassId: _this.params.productClassIds,
            catgName: _this.params.catgNames,
          },
        });
        }
        //     if(params.data){

        // }
      });
      myChart.setOption(option);
    },
    buttondis() {
      let _this = this;
      console.log(_this.params.productClassIds, "_this.params.productClassIds");
      _this.$router.push({
        path: "productSeach",
        query: {
          areaProv: _this.provcode,
          provName: _this.provName,
          params: JSON.stringify(_this.params),
          productClassId: _this.params.productClassIds,
          catgName: _this.params.catgNames,
        },
      });
    },
  },
};
</script>

<style lang="less">
.geography {
  box-sizing: border-box;
  margin-bottom: 50px;
  .indicatorbanner {
    height: 234px;
    background: #dceaff;
    background: url("../../../../static/images/productsbanner.png");
    .indicatorCon {
      width: 1180px;
      height: 234px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .conleft {
        width: 100%;
        height: 234px;
        .leftTitle {
          width: 216px;
          height: 50px;
          font-size: 36px;
          color: #2c6eff;
          font-weight: 900;
          line-height: 50px;
          margin: 72px 0 0 0;
        }

        .leftCon {
          width: 293px;
          // height: 28px;
          line-height: 28px;
          font-size: 20px;
          margin-top: 10px;
          color: #2c6eff;
          display: flex;
          align-items: center;
          overflow: hidden; // 溢出隐藏
          text-overflow: ellipsis; // 溢出用省略号显示
          // display: -webkit-box; // 作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式：从上到下垂直排列
          -webkit-line-clamp: 2;
          // -webkit-box-align: left !important;
        }
        .leftBtn {
          width: 104px;
          height: 34px;
          text-align: center;
          line-height: 34px;
          background-color: #ff964a;
          font-size: 14px;
          color: #ffffff;
          cursor: pointer;
          margin-left: 66px;
        }
      }
      .conRight {
        display: flex;
        width: 100%;
        height: 100%;
        align-items: center;
        .conRight_img {
          margin-left: 50px;
          display: flex;
          flex-direction: column;
          align-items: center;
          cursor: pointer;
          //  border-radius: 50%;

          p {
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #0b4ef4;
            margin-top: 19px;
          }
        }
      }
    }
  }
  .header {
    padding: 30px 0;
    text-align: center;
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    font-weight: 900;
    // font-stretch: normal;
    line-height: 40px;
    letter-spacing: 0px;
    color: #222222;
    box-sizing: border-box;
  }
  .main {
    width: 1180px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    .main_left {
      width: 240px;
      margin-right: 16px;
      .main_left_header {
        height: 99px;
        padding: 16px 22px;
        background-color: #f2f5fa;
        box-shadow: 0px 2px 8px 0px #c3d6f9;
        position: relative;
        .main_left_title {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          font-weight: 900;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          margin-bottom: 6px;
          font-weight: 900;
        }
        .main_left_gis {
          font-size: 12px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 20px;
          letter-spacing: 0px;
          color: #6a80a6;
          width: 162px;
          overflow: hidden; // 溢出隐藏
          text-overflow: ellipsis; // 溢出用省略号显示
          display: -webkit-box; // 作为弹性伸缩盒子模型显示。
          -webkit-box-orient: vertical; // 设置伸缩盒子的子元素排列方式：从上到下垂直排列
          -webkit-line-clamp: 2;
        }
        .main_left_img {
          width: 58px;
          height: 64px;
          position: absolute;
          right: 0;
          bottom: 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }
      .main_left_footer {
        margin-top: 16px;
        height: 693px;
        background-color: #ffffff;
        box-shadow: 0px 2px 8px 0px #efefef;
        box-sizing: border-box;
        border-radius: 4px;
        .main_left_checkbox {
          padding: 10px 20px 0 20px;
          .el-checkbox-group {
            .el-checkbox {
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              letter-spacing: 0px;
              color: #222222;
              .el-checkbox__input {
                .el-checkbox__inner {
                  border-radius: 2px;
                  border: solid 1px #b9c7d6;
                }
              }
            }
          }
        }
        .line {
          // width: 200px;
          // height: 1px;
          margin-top: 17px;
          padding: 0 20px;

          p {
            border: solid 1px #e3e8f1;
          }
        }

        .ProducTtype {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          font-weight: 700;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          padding: 10px 0 5px 20px;
          .ProducTtype_span {
            display: inline-block;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #2c6eff;
            cursor: pointer;
          }
        }
        .ProducTtypes {
          font-family: PingFangSC-Medium;
          font-size: 16px;
          font-weight: 600;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          padding: 19px 0 5px 20px;
          .ProducTtype_span {
            display: inline-block;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #2c6eff;
            // cursor: pointer;
          }
        }
        .main_left_search {
          padding: 0 20px 10px 20px;
          .el-input {
            .el-input__inner {
              border-radius: 2px;
              border: solid 1px #c4d0e4;
            }
          }
        }
        .main_left_fruit1 {
          height: 443px;
          width: 100%;
          overflow: auto;
          .main_left_subclass:hover {
            // border-bottom:  2px  solid #e3e8f1;
            background-color: #ff964a;
            color: #fff;
          }
          .main_left_switchIndex {
            // border-bottom:  2px  solid #e3e8f1;
            background-color: #ff964a;
            color: #fff;
          }
          .main_left_subclass {
            height: 36px;
            // background-color: #ff964a;
            padding: 0 20px;
            line-height: 36px;
            font-size: 14px;
            cursor: pointer;
            div {
              border-bottom: 2px solid #e3e8f1;
            }
          }
        }
      }
    }
    .main_right {
      width: 924px;
      .main_search {
        width: 100%;
        height: 99px;
        background-color: #ffffff;
        box-shadow: 0px 2px 8px 0px #efefef;
        border-radius: 4px;
        padding: 16px 30px 18px 20px;
        display: flex;
        // background: url('../../../static/images/products.png') no-repeat;
        .main_search_p {
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #222222;
          margin-bottom: 12px;
        }
        .main_search_input {
          .el-input__inner {
            border-radius: 2px;
            border: solid 1px #c4d0e4;
            // height: 34px;
          }
        }
        .main_search_btn {
          .el-button {
            width: 104px;
            height: 34px;
            background-color: #ff964a;
            margin-top: 32px;
            line-height: 0;
          }
        }
      }
      .main_echarts {
        width: 100%;
        height: 693px;
        background-color: #ffffff;
        box-shadow: 0px 2px 8px 0px #efefef;
        border-radius: 4px;
        margin-top: 16px;
        position: relative;
        .Distribution_map {
          position: absolute;
          top: 20px;
          left: 20px;
          .main_search_btn {
            .el-button {
              width: 104px;
              height: 34px;
              background-color: #ff964a;
              // margin-top: 32px;
              line-height: 0;
            }
          }
        }
      }
    }
  }
  .geography_el_dialog {
    .el-dialog__header {
      background-color: #ff964a;

      .el-dialog__title {
        color: #fff;
      }
      .el-dialog__headerbtn {
        .el-dialog__close {
          color: #fff;
        }
      }
    }
    .el-dialog__footer {
      .dialog-footer {
        .el-button--primary {
          background-color: #ff964a;
          color: #fff;
        }
      }
    }
  }
}
.geography /deep/ .el-select-dropdown__item {
  width: calc(100% - 10px);
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 200px;
}
.geography /deep/ .el-select-dropdown__list {
  width: 200px;
}
.geography .el-select-dropdown__list {
  width: 100px !important;
}
.geography_el_dialog .el-checkbox__inner {
  border-radius: 50%;
}
</style>


// WEBPACK FOOTER //
// src/views/homePage/compontents/geography.vue